export const OPEN_TIIME_BUSINESS_INTEGRATION_ON_NAVIGATION = 'OPEN_TIIME_BUSINESS_INTEGRATION_ON_NAVIGATION';
